import moment from "moment";

import {createReport, pdfFileName} from "@/utils/pdfKit";
import {kickOffLabel, matchCompetition, matchTitle} from "@/utils/convocation";

// Convocazione da mandare alle famiglie: gara, ritrovo, divisa, convocati, staff
export const generateConvocationPDF = ({
	match,
	clubName,
	teamName,
	info,
	players,
	staff,
}) => {
	const day = match?.startDate
		? moment(match.startDate).format("dddd D MMMM YYYY")
		: "";
	const report = createReport({
		title: "Convocazione",
		club: [...new Set([clubName, teamName].filter(Boolean))].join(" · "),
		subtitle: [matchTitle(match), day && day[0].toUpperCase() + day.slice(1)],
	});
	report.header();
	report.infoCard([
		{label: "Competizione", value: matchCompetition(match)},
		{label: "Giornata", value: match?.competitionSeasonGroupRoundName},
		{label: "Calcio d'inizio", value: kickOffLabel(match)},
		{label: "Campo", value: match?.fieldName},
	]);
	report.facts([
		{
			label: "Ritrovo",
			value: [
				info.meetingAt && moment(info.meetingAt).format("HH:mm"),
				info.meetingPlace,
			]
				.filter(Boolean)
				.join(" · "),
		},
		{label: "Divisa", value: info.kit},
	]);
	report.section(`Convocati (${players.length})`);
	report.table(
		[
			{label: "Giocatore", width: 5, bold: true},
			{label: "Ruolo", width: 3},
			{label: "Anno", width: 1.2, align: "right"},
		],
		players.map((p) => [p.name, p.role, p.year]),
	);
	if (staff.length) {
		report.section("Staff");
		report.table(
			[
				{label: "Nome", width: 5, bold: true},
				{label: "Ruolo", width: 4.2},
			],
			staff.map((s) => [s.name, s.role]),
		);
	}
	report.paragraph("Note", info.notes);
	report.finish(
		pdfFileName(
			"convocazione",
			teamName || clubName,
			match?.startDate && moment(match.startDate).format("YYYYMMDD"),
		),
	);
};
